<template>
  <a :href="href"
     aria-label="OnGeo">
    <img :height="`${isMobile ? 32 : 44}px`"
         :width="`${isMobile ? 160 : 220}px`"
         :src="logo"
         alt="OnGeo Logo"
         style="object-fit: contain;">
  </a>
</template>

<script>
export default {
  name: "vue-ongeo-logo",
  props: {
    href: String,
    isMobile: Boolean
  },
  computed: {
    logo () {
      if (this.$vuetify.theme.dark)
        return require('../assets/logo_ongeo_by_dark.svg');
      return require('../assets/logo_ongeo_by.svg');
    }
  }

};
</script>
